import { render } from "./SJTXinventory.vue?vue&type=template&id=3f9f8e80&scoped=true"
import script from "./SJTXinventory.vue?vue&type=script&lang=js"
export * from "./SJTXinventory.vue?vue&type=script&lang=js"

import "./SJTXinventory.vue?vue&type=style&index=0&id=3f9f8e80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f9f8e80"

export default script